import theme from 'styled-theming';
var getSuccessfulBorderColor = theme('mode', {
  light: 'var(--tertiaryGreen)',
  dark: 'var(--dark-tempColor)'
});
var getSuccessfulBackgroundColor = theme('mode', {
  light: 'var(--tertiaryGreen)',
  dark: 'var(--dark-tempColor)'
});
var getWarningBackgroundColor = theme('mode', {
  light: 'var(--tertiaryYellow)',
  dark: 'var(--tempColor)'
});
var getSuccessfulTextColor = theme('mode', {
  light: 'var(--white)',
  dark: 'var(--dark-tempColor)'
});
var getWarningTextColor = theme('mode', {
  light: 'var(--charcoal)',
  dark: 'var(--dark-tempColor)'
});
var getErrorBorderColor = theme('mode', {
  light: 'var(--red)',
  dark: 'var(--dark-tempColor)'
});
var getErrorBackgroundColor = theme('mode', {
  light: 'var(--red)',
  dark: 'var(--dark-tempColor)'
});
var getErrorTextColor = theme('mode', {
  light: 'var(--white)',
  dark: 'var(--dark-tempColor)'
});
export default {
  getSuccessfulBorderColor: getSuccessfulBorderColor,
  getSuccessfulBackgroundColor: getSuccessfulBackgroundColor,
  getSuccessfulTextColor: getSuccessfulTextColor,
  getErrorBorderColor: getErrorBorderColor,
  getErrorBackgroundColor: getErrorBackgroundColor,
  getErrorTextColor: getErrorTextColor,
  getWarningBackgroundColor: getWarningBackgroundColor,
  getWarningTextColor: getWarningTextColor
};